import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import authService from './authService'

// Get User From Local Storage
const user = JSON.parse(localStorage.getItem('user'))

const initialState = {
  user: user ?? null,
  isError: false,
  isLoading: false,
  isSuccess: false,
  sidebarShow: true,
  message: '',
}

// Login User
export const login = createAsyncThunk('auth/login', async (credentials, thunkAPI) => {
  try {
    // eslint-disable-next-line no-console
    console.debug('----- login  api trigggered -------')
    return await authService.login(credentials)
  } catch (error) {
    console.debug(error)
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString()
    return thunkAPI.rejectWithValue(message)
  }
})

export const logout = createAsyncThunk('auth/logout', async (_, thunkAPI) => {
  await authService.logout()
})

export const dummyLogin = createAsyncThunk('auth/dummyLogin', async (credentials, thunkAPI) => {
  try {
    thunkAPI.dispatch(setUser(credentials))
    return await authService.dummyLogin(credentials)
  } catch (error) {
    console.debug(error)
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString()
    return thunkAPI.rejectWithValue(message)
  }
})

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    reset: (state) => {
      state.isError = false
      state.isLoading = false
      state.isSuccess = false
      state.message = ''
    },
    setUser: (state, action) => {
      state.user = action.payload.user
    },
    toggleSidebar: (state, action) => {
      state.sidebarShow = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(dummyLogin.pending, (state) => {
        state.isLoading = true
      })
      .addCase(dummyLogin.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.user = action.payload
        state.message = action.payload?.data?.message
      })
      .addCase(dummyLogin.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
      })
      .addCase(login.pending, (state) => {
        state.isLoading = true
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.user = {
          user: action.payload?.data?.user,
          scopes: action.payload?.data?.scopes,
        }
        state.message = action.payload?.data?.message
      })
      .addCase(login.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
      })
      .addCase(logout.pending, (state) => {
        state.isLoading = true
      })
      .addCase(logout.fulfilled, (state) => {
        localStorage.removeItem('authTokens')
        localStorage.removeItem('user')
        state.user = null
        state.isLoading = false
        window.location.replace('/')
      })
      .addCase(logout.rejected, (state, action) => {
        state.isError = true
        state.message = action.payload
      })
  },
})

export const { reset, setUser, toggleSidebar } = authSlice.actions
export default authSlice.reducer
